import React, {Component} from 'react';
import {Icon, Tooltip} from 'antd';
import ProgressForDashboard from './ProgressForDashboard.js';

class VirtualMachineCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            virtualMachine: this.props.virtualMachine,
            loading: this.props.loading
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            virtualMachine: nextProps.virtualMachine,
            loading: nextProps.loading
        });
    }

    unPinVM = () => {
        const hostName = this.state.virtualMachine.hostName;
        this.props.unPinVM(hostName);
    }

    render() {
        const virtualMachine = this.state.virtualMachine;

        return (
            <div className="virtual-machine-card">
                <div className="virtual-machine-card-head">{virtualMachine.hostName}
                    <div className="virtual-machine-card-unpin" onClick={this.unPinVM}>
                        <Tooltip title='Pinned'>
                            <Icon type="pushpin"/>
                        </Tooltip>
                    </div>
                </div>
                <div className="virtual-machine-card-content">
                    <div className="virtual-machine-card-dashboard">
                        <ProgressForDashboard percent={virtualMachine.cpu} level={virtualMachine.cpuLevel} type='CPU'/>
                    </div>
                    <div className="virtual-machine-card-dashboard">
                        <ProgressForDashboard percent={virtualMachine.memory} level={virtualMachine.memoryLevel} type='Memory'/>
                    </div>
                    <div className="virtual-machine-card-dashboard">
                        <ProgressForDashboard percent={virtualMachine.disk} level={virtualMachine.diskLevel} type='Disk'/>
                    </div>
                </div>
                <div className="virtual-machine-card-foot">{virtualMachine.containerCount} containers</div>
            </div>
        );
    }
}

export default VirtualMachineCard;


// WEBPACK FOOTER //
// ./src/modules/dashboard/VirtualMachineCard.js